<template>
  <main>
    <payment-form
      v-if="pricePerEnrol > 0"
      v-bind="paymentFormProps"
      @paymentComplete="onPaymentComplete"
    />
    <free-purchase-form
      v-else
      v-bind="freePurchaseFormProps"
      @paymentComplete="onPaymentComplete"
    />
  </main>
</template>

<script>
import PaymentForm from './PaymentForm.vue';
import FreePurchaseForm from './FreePurchaseForm.vue';

export default {
  components: { PaymentForm, FreePurchaseForm },
  props: {
    pricePerEnrol: { type: Number, required: true },
    participants: { type: Array, required: true },
    organizer: { type: Object, required: true },
    courseTitle: { type: String, required: true },
    courseId: { type: Number, required: true },
    isPartnerCourse: { type: Boolean, required: true },
    partnerId: { type: Number, required: false, default: null },
    stripeApiKey: { type: String, required: true },
    stripeAccountId: { type: String, required: false, default: null },
    currentUserInformation: { type: String, required: true },
  },
  computed: {
    paymentFormProps() {
      return {
        pricePerEnrol: this.pricePerEnrol,
        participants: this.participants,
        organizer: this.organizer,
        courseTitle: this.courseTitle,
        courseId: this.courseId,
        isPartnerCourse: this.isPartnerCourse,
        partnerId: this.partnerId,
        stripeApiKey: this.stripeApiKey,
        stripeAccountId: this.stripeAccountId,
        currentUserInformation: this.currentUserInformation,
      };
    },
    freePurchaseFormProps() {
      return {
        participants: this.participants,
        organizer: this.organizer,
        courseTitle: this.courseTitle,
        courseId: this.courseId,
        isPartnerCourse: this.isPartnerCourse,
        partnerId: this.partnerId,
      };
    },
  },
  methods: {
    onPaymentComplete(message) {
      this.$emit('paymentComplete', message);
    },
  },
};
</script>
